module.exports = __webpack_public_path__ + "img/service_img5.e02be2af.png";